export default __webpack_public_path__ + "static/media/Mask of the Strange Beyond.063b2e63.jpg";